export const defaultState: Fields = {
  isActive: false,
};

export interface Fields {
  isActive: boolean;
}
